import { FileDropzone } from 'lead-list/components/FileDropzone';
import { PageHeading } from 'lead-list/components/PageHeading';
import { Paper } from 'lead-list/components/Paper';
import { useStateMachine } from 'little-state-machine';
import { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router';
import { STEPS } from '../../LeadListCreate';
import { Nav } from '../Nav';
import { StepContainer } from '../StepContainer';
import messages from './messages';

function updateFile(state, file: File | null) {
  return {
    ...state,
    leadListCreate: {
      ...state.leadListCreate,
      file,
    },
  };
}

export const StepSelectFile: FC = () => {
  const { formatMessage } = useIntl();

  const navigate = useNavigate();
  const {
    actions,
    state: { leadListCreate },
  } = useStateMachine({ updateFile });
  const [goGreen, setGoGreen] = useState(false);
  const [goRed, setGoRed] = useState(false);

  const nextStep = () => {
    setGoGreen(true);
    setTimeout(() => {
      navigate(STEPS.selectCampaign);
    }, 1000);
  };

  const markError = () => {
    setGoRed(true);
    setTimeout(() => {
      setGoRed(false);
    }, 5000);
  };

  const selectFile = (file: File) => {
    if (!file) return;
    actions.updateFile(file);
    if (!leadListCreate.hasSeenFileUpload && leadListCreate.file?.name) {
      nextStep();
    }
  };

  useEffect(() => {
    if (
      !leadListCreate.hasSeenFileUpload &&
      leadListCreate.file?.name &&
      !leadListCreate.fileProcessingError &&
      leadListCreate.fileProcessed
    ) {
      nextStep();
    } else if (leadListCreate.fileProcessingError) {
      markError();
    }
  }, [
    leadListCreate.hasSeenFileUpload,
    leadListCreate.file?.name,
    leadListCreate.fileProcessingError,
    leadListCreate.fileProcessed,
  ]);

  return (
    <StepContainer>
      <PageHeading title={formatMessage(messages.uploadTitle)} />

      <Paper
        variant="outlined"
        shade={goGreen ? 'success' : goRed ? 'error' : undefined}
        sx={(theme) => ({
          width: '100%',
          padding: theme.spacing(3),
        })}
      >
        <FileDropzone
          selectedFile={leadListCreate.file}
          onDrop={(acceptedFiles, _fileRejections) => {
            if (acceptedFiles[0]) {
              selectFile(acceptedFiles[0]);
            } else {
              console.error('Error getting file');
            }
          }}
          allowedFileTypes=".csv"
        />
      </Paper>
      <Nav
        onForwardClick={leadListCreate.hasSeenFileUpload ? nextStep : undefined}
        disableBack={goGreen}
        disableForward={goGreen}
      />
    </StepContainer>
  );
};
